<template>
  <HoverArea :width="width" :height="height" :is-vertical="isVertical">
    <ContainerProduction v-bind="containerProps">
      <slot />
    </ContainerProduction>
  </HoverArea>
</template>

<script>
import HoverArea from "@bloglovin/inspire-engine/Components/HoverArea.vue";
import ContainerProduction from "%/dynamic-component-editor/standard-elements/layouts/ContainerProduction.vue";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import StaticLayoutDirection from "%/dynamic-component-editor/options/static-layout-direction";

// The engine HoverArea tracks the pointer and provides it to HoverVisibleContainer; the DCE container lays out.
export default {
  name: "HoverAreaContainer",
  components: { HoverArea, ContainerProduction },
  production: true,
  mixins: [DynamicElementMixin],
  inheritAttrs: false,
  computed: {
    containerProps() {
      return {
        ...this.$attrs,
        optionValues: this.optionValues,
        activeState: this.activeState,
        identifier: this.identifier,
        themeMode: this.themeMode,
        editMode: this.editMode,
      };
    },
    width() {
      return this.getOptionValue(LayoutWidth) || "hug";
    },
    height() {
      return this.getOptionValue(LayoutHeight) || "hug";
    },
    isVertical() {
      return this.getOptionValue(StaticLayoutDirection) === "vertical";
    },
  },
};
</script>
